import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppleRestrictionsProfilePreset } from '@rocksoft/mdm-sdk-v2';

export type RestrictionsProfileState = EntityState<AppleRestrictionsProfilePreset>;

export function selectIdFromRestrictionsProfile(conf: AppleRestrictionsProfilePreset): string {
  return conf.uniqueId;
}

export const adapter: EntityAdapter<AppleRestrictionsProfilePreset> =
  createEntityAdapter<AppleRestrictionsProfilePreset>({
    selectId: selectIdFromRestrictionsProfile,
  });

export const initialState: RestrictionsProfileState = adapter.getInitialState();
